import "./index.css";
import GasFeeApp from "./GasFeeApp";

export function App() {
  return <GasFeeApp />;
}

export default App;
